
import { Vue, Component, Prop } from 'vue-property-decorator';

import UiButton from '@/components/button/ui-button.vue';
import InfoIcon from '@/components/icons/CancelInfoIcon.vue';

import ModalFullScreen from '@/components/modal/ModalFullScreenNew.vue';

import { User } from '@/generated/graphql';

@Component({
	components: {
		UiButton,
		InfoIcon,
		ModalFullScreen,
	},
})
export default class CancelInvoiceModal extends Vue {
	user: User | null = null;
	@Prop({ type: Boolean, default: false }) readonly value!: boolean;

	handleClose(): void {
		this.$emit('input', false);
	}

	cancelInvoice(): void {
		this.$emit('cancelInvoice');
		this.handleClose();
	}
}
